

// Variable global para almacenar el intervalo del contador
let countdownInterval = null;

// Función para detener cualquier intervalo activo
function stopCountdown() {
    if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
    }
}

// ========== FUNCIONES PARA MODALES ==========

// Función para mostrar modal FLASH
function showFlashModal() {
    const modal = document.getElementById('flash-modal');
    if (modal) {
        modal.style.display = 'block';
    }
}

// Función para mostrar modal EXPRESS
function showExpressModal() {
    const modal = document.getElementById('express-modal');
    if (modal) {
        modal.style.display = 'block';
    }
}

// Función para cerrar modales
function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'none';
    }
}

// Event listeners para cerrar modales al hacer click fuera
window.onclick = function(event) {
    const flashModal = document.getElementById('flash-modal');
    const expressModal = document.getElementById('express-modal');
    
    if (event.target === flashModal) {
        flashModal.style.display = 'none';
    }
    if (event.target === expressModal) {
        expressModal.style.display = 'none';
    }
}

// ========== ENVÍO FLASH ==========

// Función para restaurar estilos del elemento
function restoreElementStyles() {
    const deliveryElement = document.getElementById("delivery-message");
    if (deliveryElement) {
        deliveryElement.style.display = 'block';
        deliveryElement.style.padding = '';
        deliveryElement.style.margin = '';
        deliveryElement.style.boxShadow = '';
        deliveryElement.style.background = '';
        deliveryElement.style.border = '';
        deliveryElement.style.height = '';
        deliveryElement.style.width = '';
        deliveryElement.style.overflow = '';
        // Quitar la clase de oculto si existe
        deliveryElement.classList.remove('hidden-delivery');
    }
}

// FLASH: llega hoy en 2 horas
function showFlashSameDayDelivery() {
    stopCountdown();
    
    // Restaurar estilos del elemento
    restoreElementStyles();
    
    const cutOffTime = new Date();
    const esSabado = cutOffTime.getDay() === 6;
    
    // Horarios de corte para FLASH
    if (esSabado) {
        cutOffTime.setHours(14);
        cutOffTime.setMinutes(0);
    } else {
        cutOffTime.setHours(17);
        cutOffTime.setMinutes(30);
    }
    cutOffTime.setSeconds(0);
    
    updateFlashCountdown(cutOffTime);
    countdownInterval = setInterval(() => updateFlashCountdown(cutOffTime), 1000);
}

// Función para actualizar el contador FLASH
function updateFlashCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    
    // Si el tiempo ya pasó, ocultar el componente
    if (timeDifference <= 0) {
        stopCountdown();
        const deliveryElement = document.getElementById("delivery-message");
        if (deliveryElement) {
            deliveryElement.innerHTML = '';
            deliveryElement.classList.add('hidden-delivery');
        }
        return;
    }
    
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="flash-banner">
            LLEGA EN 2H CON <span class="flash-text">ENVIO FLASH</span>
            <span class="info-icon" onclick="showFlashModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        <div class="countdown-title">Pide antes de <span class="remaining-time">${horasFaltantes}h ${minutosFaltantes}m ${segundosFaltantes}s</span></div>
        <div class="province-info">Sólo a 6km de Santiago Centro</div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modal FLASH si no existe
    if (!document.getElementById('flash-modal')) {
        const modalHtml = `
            <div id="flash-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('flash-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO FLASH</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 17:30 / Sab 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
}

// ========== ENVÍO EXPRESS ==========

// EXPRESS: mismo día
function showExpressSameDayDelivery() {
    stopCountdown();
    
    // Restaurar estilos del elemento
    restoreElementStyles();
    
    const cutOffTime = new Date();
    cutOffTime.setHours(16);
    cutOffTime.setMinutes(0);
    cutOffTime.setSeconds(0);
    
    updateExpressCountdown(cutOffTime);
    countdownInterval = setInterval(() => updateExpressCountdown(cutOffTime), 1000);
}

// Función para actualizar el contador EXPRESS
function updateExpressCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    
    // Si el tiempo ya pasó, ocultar el componente
    if (timeDifference <= 0) {
        stopCountdown();
        const deliveryElement = document.getElementById("delivery-message");
        if (deliveryElement) {
            deliveryElement.innerHTML = '';
            deliveryElement.classList.add('hidden-delivery');
        }
        return;
    }
    
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="express-banner">
            RECIBE HOY CON <span class="express-text">ENVIO EXPRESS</span>
            <span class="info-icon" onclick="showExpressModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        <div class="countdown-title">Pide antes de <span class="remaining-time">${horasFaltantes}h ${minutosFaltantes}m ${segundosFaltantes}s</span></div>
        <div class="province-info">Sólo en la provincia de Santiago Urbano</div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modal EXPRESS si no existe
    if (!document.getElementById('express-modal')) {
        const modalHtml = `
            <div id="express-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('express-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO EXPRESS</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 16:00 / Sab 14:30</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
}

// ========== FUNCIÓN PARA VERIFICAR DISPONIBILIDAD ==========

function checkServiceAvailability() {
    const now = new Date();
    const currentDay = now.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour * 60 + currentMinute; // Tiempo en minutos desde medianoche
    
    let flashAvailable = false;
    let expressAvailable = false;
    
    // Verificar disponibilidad de FLASH
    if (currentDay >= 1 && currentDay <= 5) { // Lunes a Viernes
        const flashCutoff = 17 * 60 + 30; // 17:30 en minutos
        flashAvailable = currentTime < flashCutoff;
    } else if (currentDay === 6) { // Sábado
        const flashCutoff = 14 * 60; // 14:00 en minutos
        flashAvailable = currentTime < flashCutoff;
    }
    
    // Verificar disponibilidad de EXPRESS
    if (currentDay >= 1 && currentDay <= 5) { // Lunes a Viernes
        const expressCutoff = 16 * 60; // 16:00 en minutos
        expressAvailable = currentTime < expressCutoff;
    } else if (currentDay === 6) { // Sábado
        const expressCutoff = 14 * 60 + 30; // 14:30 en minutos
        expressAvailable = currentTime < expressCutoff;
    }
    
    return { flashAvailable, expressAvailable };
}

// ========== FUNCIÓN PARA MOSTRAR AMBOS SERVICIOS ==========

function showBothServices() {
    stopCountdown();
    
    // Restaurar estilos del elemento
    restoreElementStyles();
    
    const now = new Date();
    const esSabado = now.getDay() === 6;
    
    // Configurar horarios de corte
    const flashCutoff = new Date();
    const expressCutoff = new Date();
    
    if (esSabado) {
        flashCutoff.setHours(14, 0, 0);
        expressCutoff.setHours(14, 30, 0);
    } else {
        flashCutoff.setHours(17, 30, 0);
        expressCutoff.setHours(16, 0, 0);
    }
    
    updateBothServicesCountdown(flashCutoff, expressCutoff);
    countdownInterval = setInterval(() => updateBothServicesCountdown(flashCutoff, expressCutoff), 1000);
}

function updateBothServicesCountdown(flashCutoff, expressCutoff) {
    const now = new Date();
    
    // Calcular tiempo restante para FLASH y EXPRESS
    let flashTimeDiff = flashCutoff.getTime() - now.getTime();
    let expressTimeDiff = expressCutoff.getTime() - now.getTime();
    
    // Verificar qué servicios siguen disponibles
    const flashStillAvailable = flashTimeDiff > 0;
    const expressStillAvailable = expressTimeDiff > 0;
    
    // Si ambos servicios ya no están disponibles, ocultar completamente
    if (!flashStillAvailable && !expressStillAvailable) {
        stopCountdown();
        const deliveryElement = document.getElementById("delivery-message");
        if (deliveryElement) {
            deliveryElement.innerHTML = '';
            deliveryElement.classList.add('hidden-delivery');
        }
        return;
    }
    
    // Si solo uno está disponible, cambiar a función individual
    if (flashStillAvailable && !expressStillAvailable) {
        stopCountdown();
        showFlashSameDayDelivery();
        return;
    }
    
    if (!flashStillAvailable && expressStillAvailable) {
        stopCountdown();
        showExpressSameDayDelivery();
        return;
    }
    
    // Ambos servicios siguen disponibles, continuar con el contador
    flashTimeDiff = Math.max(flashTimeDiff, 0);
    expressTimeDiff = Math.max(expressTimeDiff, 0);
    
    const flashHours = Math.floor(flashTimeDiff / (1000 * 60 * 60));
    const flashMinutes = Math.floor((flashTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const flashSeconds = Math.floor((flashTimeDiff % (1000 * 60)) / 1000);
    
    const expressHours = Math.floor(expressTimeDiff / (1000 * 60 * 60));
    const expressMinutes = Math.floor((expressTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const expressSeconds = Math.floor((expressTimeDiff % (1000 * 60)) / 1000);
    
    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="flash-banner">
            LLEGA EN 2H CON <span class="flash-text">ENVIO FLASH</span>
            <span class="info-icon" onclick="showFlashModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        <div class="countdown-title">Pide antes de <span class="remaining-time">${flashHours}h ${flashMinutes}m ${flashSeconds}s</span></div>
        <div class="province-info">Sólo a 6km de Santiago Centro</div>
        
        <div style="margin-top: 5px;">
            <div class="express-banner">
                RECIBE HOY CON <span class="express-text">ENVIO EXPRESS</span>
                <span class="info-icon" onclick="showExpressModal()">
                    <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                        <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                    </svg>
                </span>
            </div>
            <div class="countdown-title">Pide antes de <span class="remaining-time">${expressHours}h ${expressMinutes}m ${expressSeconds}s</span></div>
            <div class="province-info">Sólo en la provincia de Santiago Urbano</div>
        </div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modales si no existen
    if (!document.getElementById('flash-modal')) {
        const flashModalHtml = `
            <div id="flash-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('flash-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO FLASH</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 17:30 / Sab 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', flashModalHtml);
    }
    
    if (!document.getElementById('express-modal')) {
        const expressModalHtml = `
            <div id="express-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('express-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO EXPRESS</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 16:00 / Sab 14:30</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', expressModalHtml);
    }
}

// ========== FUNCIÓN PRINCIPAL ACTUALIZADA ==========

function deliveryMessage(option) {
    stopCountdown();
    
    // Si no se especifica opción, detectar automáticamente qué servicios mostrar
    if (!option) {
        const availability = checkServiceAvailability();
        
        if (availability.flashAvailable && availability.expressAvailable) {
            // Mostrar ambos servicios
            showBothServices();
        } else if (availability.flashAvailable) {
            // Solo FLASH disponible
            showFlashSameDayDelivery();
        } else if (availability.expressAvailable) {
            // Solo EXPRESS disponible
            showExpressSameDayDelivery();
        } else {
            // Ningún servicio disponible - Ocultar completamente
            const deliveryElement = document.getElementById("delivery-message");
            if (deliveryElement) {
                deliveryElement.innerHTML = '';
                // Agregar clase para ocultar en lugar de estilos inline
                deliveryElement.classList.add('hidden-delivery');
            }
        }
        return;
    }
    
    // Lógica original para cuando se especifica una opción
    if (option === 1) {
        // ENVÍO FLASH
        showFlashSameDayDelivery();
    } else if (option === 2) {
        // ENVÍO EXPRESS
        showExpressSameDayDelivery();
    } else if (option === 3) {
        // AMBOS SERVICIOS
        showBothServices();
    }
}

// Por defecto, detectar automáticamente qué servicios mostrar
deliveryMessage();